<template>
  <span
    class="ml-auto inline-block rounded border border-green-500/25 px-1.5 py-0.5 text-xs font-semibold uppercase leading-tight text-green-500"
  >
    {{ $t('components.app_product_card.new') }}
  </span>
</template>
